export default class RoleDisplay {
  code: string;
  displayName: string;
  constructor(code: string, displayName: string) {
    this.code = code;
    this.displayName = displayName;
  }
}